// Hero branding logo — scroll-driven scale/fade overlay (homepage hero).
// Updates CSS custom properties on each <hero-branding-logo>; the child
// .hero-branding__logo reads them via component-hero.css. The hard opacity:0
// cutover is handled in CSS via the existing html.sticky-header-show class,
// so JS only ramps scale + opacity over the first `end` px of scroll.
if (!customElements.get('hero-branding-logo')) {
  customElements.define('hero-branding-logo', class extends HTMLElement {
    connectedCallback() {
      this.end = 300; // matches the sticky-header-show threshold in global.js
      this.minScale = parseFloat(getComputedStyle(this).getPropertyValue('--hero-branding-min-scale')) || 0.6;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const p = Math.min(Math.max(window.scrollY / this.end, 0), 1); // 0 -> 1
      const scale = 1 - (1 - this.minScale) * p;
      this.style.setProperty('--hero-branding-scale', scale.toFixed(4));
      this.style.setProperty('--hero-branding-opacity', (1 - p).toFixed(4));
    }
  });
}
